import React, { useEffect, useState } from "react";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import FormUtente from "./FormUtente";
import RiepilogoDocumenti from "./RiepilogoDocumenti";
import { useGetUserByIdQuery } from "../../api/admin/gestisciUtentiApi";
import { FormGroup, IconButton, Tab, Tabs } from "@mui/material";
import { useReactiveEmailMutation } from "../../api/admin/gestisciUtentiApi";
import { toast } from "react-toastify";
import { t } from "i18next";
import {
  useGetUserStatsByUserIdQuery,
  useLazyExportExcelQuery,
} from "../../api/admin/gestisciDocumentiApi";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import { useSelector } from "react-redux";
import FamilyComponent from "../NucleoFamiliare/FamilyComponent";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import CoreMaxCharacter from "../../../app/core/components/CoreMaxCharacter/CoreMaxCharacter";

const SchedaUtente = ({ userId, onClose }) => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const TabsContent = Object.freeze({
    documentStats: 0,
    activitiesStats: 1,
  });
  const [tabValue, setTabValue] = useState(0);
  const [notesOperator, setNotesOperator] = useState("");
  const [reactiveEmail] = useReactiveEmailMutation();

  const handleReactiveEmail = () => {
    reactiveEmail({ idUser: userId })
      .then((res) => {
        if (res?.data?.Result !== 1) {
          toast.error(`Errore: ${res?.data?.Exception}`);
        } else {
          toast.success("Email di riattivazione inviata");
        }
      })
      .catch((error) => {});
  };

  // Dati
  const { data: userData, isLoading: userDataIsLoading } =
    useGetUserByIdQuery(userId);
  /* Per Gestione Pratiche e Documenti */
  const { data: userStats, isLoading: userStatsLoading } =
    useGetUserStatsByUserIdQuery(userId);
  const [getExcel] = useLazyExportExcelQuery();

  const colorPrimary = useSelector((state) => state.app.primaryColor);

  useEffect(() => {
    if (userData && userData.Data && userData.Data.operatorNotes) {
      setNotesOperator(userData.Data.operatorNotes);
    }
  }, [userData]);

  const handleTabChange = (_, nv) => {
    setTabValue(nv);
  };

  const excelRequest = () =>
    new Promise((resolve, reject) => {
      getExcel(userId)
        .then((res) => {
          if (!res.isSuccess) throw new Error("Niente da fare");
          resolve(window.location.assign(window.URL.createObjectURL(res.data)));
        })
        .catch(() => reject());
    });

  const handleExcelDownload = () => {
    toast.promise(
      excelRequest,
      {
        pending: {
          render: t("HandleDownload"),
          type: "info",
        },
        success: t("FileReady"),
        error: t("ReqErr"),
      },
      { autoClose: 1500 }
    );
  };

  // Controls
  const isValidUserData = userData && userData.Data;
  const isValidUserStats = userStats && userStats.Data;

  return (
    <>
      {!userDataIsLoading &&
      isValidUserData &&
      isValidUserStats &&
      !userStatsLoading ? (
        <>
          <div>
            <h2 className="text-center">
              {t("Card")} {t("user")}
            </h2>
          </div>
          <div className="flex space-x-8">
            <div
              className="w-6/12"
              style={{
                border: "1px solid lightgrey",
                borderRadius: 10,
                padding: 15,
              }}
            >
              <FormUtente
                userData={userData}
                onClose={onClose}
                onActive={handleReactiveEmail}
                notesOperator={notesOperator}
              />
            </div>
            <div className="flex flex-col w-6/12 gap-5">
              <div
                className="w-full h-2/5"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: 10,
                  padding: 15,
                }}
              >
                {appConfig?.modules?.practice?.general && (
                  <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label={t("DocsStats")} />
                    <Tab label={t("PracticeStats")} />
                  </Tabs>
                )}
                <div hidden={tabValue !== TabsContent.documentStats}>
                  <RiepilogoDocumenti
                    userStats={userStats}
                    userData={userData}
                  />
                </div>
                <div hidden={tabValue !== TabsContent.activitiesStats}>
                  <RiepilogoDocumenti
                    userStats={userStats}
                    userData={userData}
                    isDocStats={false}
                  />
                </div>
              </div>
              {appConfig?.modules?.user?.nucleoFamily && (
                <div
                  className="w-full h-2/5"
                  style={{
                    border: "1px solid lightgrey",
                    borderRadius: 10,
                    padding: 15,
                    overflow: "auto",
                  }}
                >
                  <FamilyComponent userId={userId} />
                </div>
              )}
              <div className="flex items-center">
                <h4
                  className="uppercase m-0"
                  style={{ color: `${colorPrimary}` }}
                >
                  {t("GetUserDocsExcel")}
                </h4>
                <IconButton className="mx-4" onClick={handleExcelDownload}>
                  <DescriptionRoundedIcon className="text-green-700" />
                </IconButton>
              </div>
              <div className="w-full flex items-center ">
                <FormGroup className="w-full my-5">
                  <CoreTextArea
                    rows={5}
                    label={t("OperatorNotes")}
                    name="operatorNotes"
                    value={notesOperator}
                    onChange={(e) => setNotesOperator(e.target.value)}
                    error={notesOperator?.length > 500}
                  />
                </FormGroup>
                <CoreMaxCharacter maxCharacter={500} text={notesOperator} />
              </div>
            </div>
          </div>
        </>
      ) : (
        <CoreSpinner />
      )}
    </>
  );
};

export default SchedaUtente;
